import React, { Suspense } from 'react'
import { Route } from 'react-router-dom'
const RouteWithProps = React.lazy(() => import('App/helpers/RouteWithProps'))
const Layout = React.lazy(() => import('./Layout'))
const Main = React.lazy(() => import('./Main'))
const Front = React.lazy(() => import('./Front'))
const Back = React.lazy(() => import('./Back'))
const Liveness = React.lazy(() => import('./Liveness'))
const Error = React.lazy(() => import('./Error'))
const Camera = React.lazy(() => import('./Camera'))
const Landing = React.lazy(() => import('./Landing'))

// prettier-ignore
export default (
  <Route path="toc" element={<Suspense><Layout /></Suspense>}>
    <Route index element={<Suspense><Main /></Suspense>} />
    <Route path="front" element={<Suspense><Front /></Suspense>} />
    <Route path="back" element={<Suspense><Back /></Suspense>} />
    <Route path="liveness" element={<Suspense><Liveness /></Suspense>} />
    <Route path="error" element={<Suspense><Error /></Suspense>} />
    <Route path="camera" element={<Suspense><Camera /></Suspense>} />
    <Route path=":userId/:token" element={<Suspense><RouteWithProps component={Landing} /></Suspense>} />
  </Route>
)
